export default __webpack_public_path__ + "static/media/lipstick-cold-winter.56320686.png";